import {Enums} from "./index";

export const formatAccountType = (type) => {
	switch (type) {
		case 'TAX_INCOME':
			return 'DP (PO)';
		case 'TAX_DPP_INCOME':
			return 'DP (FO)';
		case 'TAX_EMP_INCOME':
			return 'DP (Z)';
		case 'TAX_VAT':
			return 'DPH';
		case 'TAX_VEHICLE':
			return 'DS';
		case 'TAX_SOCIAL':
			return 'SP';
		case 'TAX_HEALTH':
			return 'ZP';
		default:
			return type
	}
};

export const formatVatPeriod = (period) => {
	switch (period) {
		case 'QUARTER':
			return '3M';
		case 'MONTH':
			return '1M';
		default:
			return period
	}
};

export const getUserParty = (partyId, session) => {
	if (!session.user || !session.user.parties) {
		return null;
	}
	for (let i = 0; i < session.user.parties.length; i++) {
		if (session.user.parties[i].partyId === partyId) {
			return session.user.parties[i];
		}
	}
	return null;
};

export const getPartyAccountOptions = (partyId, enums) => {
	const accounts = Enums.createEnumItems(enums, "partyAccounts", true);
	const options = [];
	if (partyId) {
		for (let i = 0; i < accounts.length; i++) {
			if (accounts[i].parentId * 1 === partyId) {
				options.push(accounts[i]);
			}
		}
	}
	return options;
};

export const handlePartyChange = (accountFieldName, partyId, enums, change) => {
	const accountOptions = getPartyAccountOptions(partyId, enums);
	if (accountOptions && accountOptions.length === 1) {
		change(accountFieldName, accountOptions[0].value);
	} else {
		change(accountFieldName, null);
	}
};
